
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phenotypes/[slug]/variants",
      function () {
        return require("private-next-pages/phenotypes/[slug]/variants.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phenotypes/[slug]/variants"])
      });
    }
  